import React from 'react';
import intl from 'react-intl-universal';
import { InvokeModal } from 'webapp-common';

class RestoreConfirmationModal extends React.Component {
  save = () => {
    this.props.onSave();
    this.props.toggle();
  };

  render() {
    const { toggle, projectName } = this.props;
    return (
      <InvokeModal
        showModal={true}
        toggle={toggle}
        modalTitle={intl.get('app.restore')}
        cancelButtonText={intl.get('app.cancel')}
        primaryButtonText={intl.get('app.restore')}
        enableSave={true}
        save={this.save}
      >
        <p className="m-5">{intl.get('app.restore.project.confirm', { project: projectName })}</p>
      </InvokeModal>
    );
  }
}

export default RestoreConfirmationModal;
